import api from '../auth';

const slug = 'api/mrs/';

const MrsService = () => {
    const getMrss = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getMrssLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getMrs = (id) => {
        return api.get(slug + `show/${id}`).then((res) => res.data);
    };

    const deleteMrs = (id) => {
        return api
            .delete(slug + `mrs/${id}`)
            .then((res) => res.data)
            .catch((err) => {
                // 403 je već hendlovan u interceptor-u, samo proslijedi grešku dalje
                return Promise.reject(err);
            });
    };

    const createMrs = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updateMrs = (id, data) => {
        return api.put(slug + `mrs/${id}`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyMrs = (id) => {
        return api.post(slug + `copy/${id}`).then((res) => res.data);
    };

    return {
        getMrss,
        getMrssLazy,
        getMrs,
        deleteMrs,
        createMrs,
        updateMrs,
        getOptions,
        copyMrs
    };
};

export default MrsService;
